module.exports = __webpack_public_path__ + "media/src/images/balloons/iversity-banner-kursseite-black-sale-de-9fb33cd2f23270b6827dd1331fd092ef.jpg";